// src/com/tsr/TransPlanTsrViewSupplyExpress.js
import React from 'react';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import { TableContainer, Table, TableHead, TableBody, TableCell, TableRow } from '@mui/material';
import { AppWord, AppStyle } from '../../value/AppConst';
import { transPlanTsrItemRepo } from '../../value/AppModel';
import { useReactiveVar } from '@apollo/client';
import { CenterCell } from '../../common/TopStyle';


const TitleCellBg = '#e0d8f2';

const TemperTitleCell = styled(TableCell)({
    backgroundColor: '#e3fffd',
    color: AppStyle.PrimaryRGB,
    fontWeight: 'bold',
    textAlign: 'center',
});

const TitleCell = styled(TableCell)({
    backgroundColor: TitleCellBg,
    color: AppStyle.PrimaryRGB,
    fontWeight: 'bold',
    textAlign: 'center',
});

const WoodTitleCell = styled(TableCell)({
    backgroundColor: '#e0e3ca',
    fontWeight: 'bold',
    textAlign: 'center',
});

const SubTitleCell = styled(TableCell)({
    backgroundColor: TitleCellBg,
    fontWeight: 'bold',
    textAlign: 'center',
});


const WORD_OFF = 'off';

/**
 * Express 물류집기
 * @returns 
 */
export default function TransPlanTsrViewSupplyExpress() {
    const item = useReactiveVar(transPlanTsrItemRepo);

    return(
        <Box>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TemperTitleCell rowSpan={2} size={AppWord.SMALL}>&nbsp;</TemperTitleCell>
                            <TemperTitleCell rowSpan={2} size={AppWord.SMALL}>온도</TemperTitleCell>
                            <TitleCell rowSpan={2} size={AppWord.SMALL}>Dolly</TitleCell>
                            <TitleCell rowSpan={2} size={AppWord.SMALL}>Cart</TitleCell>
                            <TitleCell rowSpan={2} size={AppWord.SMALL}>Roll Cage</TitleCell>
                            <TitleCell colSpan={2} size={AppWord.SMALL}>Pallet</TitleCell>
                        </TableRow>
                        <TableRow>
                            <SubTitleCell size={AppWord.SMALL}>KPP</SubTitleCell>
                            <SubTitleCell size={AppWord.SMALL}>AJU</SubTitleCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TemperTitleCell>전면</TemperTitleCell>
                            <CenterCell>{item.tempF || WORD_OFF}</CenterCell>
                            <CenterCell>{item.eFDolly}</CenterCell>
                            <CenterCell>{item.eFDollycart}</CenterCell>
                            <CenterCell>{item.eFRoll}</CenterCell>
                            <CenterCell>{item.eFPalKpp}</CenterCell>
                            <CenterCell>{item.eFPalAju} </CenterCell>
                        </TableRow>
                        <TableRow>
                            <TemperTitleCell>중면</TemperTitleCell>
                            <CenterCell>{item.tempM || WORD_OFF}</CenterCell>
                            <CenterCell>{item.eMDolly}</CenterCell>
                            <CenterCell>{item.eMDollycart}</CenterCell>
                            <CenterCell>{item.eMRoll}</CenterCell>
                            <CenterCell>{item.eMPalKpp}</CenterCell>
                            <CenterCell>{item.eMPalAju}</CenterCell>
                        </TableRow>
                        <TableRow>
                            <TemperTitleCell>후면</TemperTitleCell>
                            <CenterCell>{item.tempR || WORD_OFF}</CenterCell>
                            <CenterCell>{item.eRDolly}</CenterCell>
                            <CenterCell>{item.eRDollycart}</CenterCell>
                            <CenterCell>{item.eRRoll}</CenterCell>
                            <CenterCell>{item.eRPalKpp}</CenterCell>
                            <CenterCell>{item.eRPalAju}</CenterCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <Box style={{height:20}}></Box>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <WoodTitleCell rowSpan={2} size={AppWord.SMALL}>담배</WoodTitleCell>
                            <WoodTitleCell rowSpan={2} size={AppWord.SMALL}>양곡</WoodTitleCell>
                            <WoodTitleCell rowSpan={2} size={AppWord.SMALL}>제지</WoodTitleCell>
                            <WoodTitleCell rowSpan={2} size={AppWord.SMALL}>MU</WoodTitleCell>
                            <WoodTitleCell colSpan={3} size={AppWord.SMALL}>Pallet</WoodTitleCell>
                        </TableRow>
                        <TableRow>
                            <WoodTitleCell size={AppWord.SMALL}>Dolly</WoodTitleCell>
                            <WoodTitleCell size={AppWord.SMALL}>Cart</WoodTitleCell>
                            <WoodTitleCell size={AppWord.SMALL}>Roll Cage</WoodTitleCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <CenterCell>{item.eCigar}</CenterCell>
                            <CenterCell>{item.eCorn}</CenterCell>
                            <CenterCell>{item.ePulp}</CenterCell>
                            <CenterCell>{item.eMu}</CenterCell>
                            <CenterCell>{item.eJumDolly}</CenterCell>
                            <CenterCell>{item.eJumDollycart}</CenterCell>
                            <CenterCell>{item.eJumRoll}</CenterCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );    
}